import type { CSSProperties } from "react"
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { faAwardSimple, faStar } from "@fortawesome/pro-regular-svg-icons"

export type PricingTier = "starter" | "plus"

export type TierMeta = {
  label: string
  icon: IconDefinition
  tagStyle: CSSProperties
  cornerClass: "tier-plus" | "tier-starter"
}

export function tierMeta(tier?: PricingTier | string): TierMeta {
  if (tier === "plus") {
    return {
      label: "Plus",
      icon: faStar,
      tagStyle: { 
        background: "#FFF7E6", 
        color: "#FA8C16", 
        borderColor: "#FFE7BA",
        display: "inline-flex",
        alignItems: "center",
    },
      
      cornerClass: "tier-plus",
    }
  }
  return {
    label: "Starter",
    icon: faAwardSimple,
    tagStyle: { 
      background: "#E6F4FF", 
      color: "#1677FF", 
      borderColor: "#BAE0FF",
      display: "inline-flex",
      alignItems: "center",
    },
    cornerClass: "tier-starter",
  }
}
